<template>
    <div class="mx-auto p-16 relative text-center">
        <p class="font-thin text-xl text-gray-600">
            {{ $t('table.empty') }}
        </p>
        <slot name="button"></slot>
    </div>
</template>

<script>
    export default {
        
    }
</script>
